import { render, staticRenderFns } from "./app-error-container.vue?vue&type=template&id=5983712c&scoped=true&"
import script from "./app-error-container.vue?vue&type=script&lang=js&"
export * from "./app-error-container.vue?vue&type=script&lang=js&"
import style0 from "./app-error-container.vue?vue&type=style&index=0&id=5983712c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983712c",
  null
  
)

/* custom blocks */
import block0 from "./app-error-container-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Fapp%2Fapp-error-container.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VImg,VRow})
